/**
 * CSK Matrix Immunity & Distillation Demo — application shell.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */
import { createMonographRouteApp } from "../MonographRouteApp.js";
import { NAVIGATION } from "./data/nav.js";
import { panelTokens } from "@csk/demo-ui";

const matrixSurfaceTokens = {
  carrier: "#38bdf8",
  distill: "#818cf8",
  immune: "#34d399",
  immuneGreen: "#34d399",
  violation: "#fb7185",
  a1: "#60a5fa",
  a2: "#a78bfa",
  a3: "#22d3ee",
  a4: "#f59e0b",
  singularAmber: "#f59e0b",
  singularRed: "#f87171",
};

export const App = createMonographRouteApp({
  navigation: NAVIGATION,
  theme: panelTokens,
  surfaceTokenAliases: [
    { prefix: "mit", tokens: matrixSurfaceTokens },
    { prefix: "vid", tokens: matrixSurfaceTokens },
  ],
  slug: "matrix-immunity-distillation",
  title: "Matrix Immunity & Distillation",
  eyebrow: "INTERACTIVE DEMO · RD-56 + RD-65",
  tagline:
    "Audit a system's eligibility for immunity, then distill an arbitrary generator set to its immune core — two faces of the Matrix Immunity Theorem over GL(n,ℂ).",
  companionPath: "research/settled/RD-56-MATRIX-IMMUNITY-THEOREM.md",
  backgroundColor: "#0a0c28",
});
